import React from 'react';

const DialogHeader = ({
    forResultUpdate
}) => {
    return (
        forResultUpdate
            ? <h2 className='mb-0'>Update Result</h2>
            :
            <div>
                <h2 className='mb-0'>Add a new result</h2>
                <h5 style={{ fontWeight: 400 }}>Results found. Please map the result with the PSID</h5>
            </div>
    );
}

export default DialogHeader;